import React, { useCallback, useRef, useState } from 'react'
import {
  Text,
  View,
  TouchableOpacity,
  FlatList,
  StyleSheet,
} from 'react-native';
import colors from "../constants/colors";
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { branding } from "../api";
import "./recordPaginator.css";

export const RecordPaginator = ({
  currentPage,
  pageSize,
  navigationHandler,
  tasksCount,
  filter,
  resultsPerPage = 10,
  totalLabel,
}) => {

  const listRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const nPages = tasksCount % resultsPerPage === 0 ? Math.trunc(tasksCount / pageSize) : Math.trunc(tasksCount / pageSize) + 1;
  const pagesArray = Array.from({ length: nPages }, (_, i) => i + 1);
  const onPressHandler = useCallback((page) => navigationHandler({ page, ...(filter != 'all' && { filter }) }), [navigationHandler, filter]);
  const isIqops = branding === "iqops";

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - listRef.current.offsetLeft);
    setScrollLeft(listRef.current.scrollLeft);
  };

  const stopDragging = () => {
    setIsDragging(false);
  };

  const onDrag = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - listRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust scroll speed
    listRef.current.scrollLeft = scrollLeft - walk;
  };

  if (isIqops) {
    return (
      <View style={iqopsStyles.wrap}>
        <View style={iqopsStyles.row}>
          {currentPage != 1 ? (
            <TouchableOpacity onPress={() => onPressHandler(currentPage - 1)} style={iqopsStyles.arrowBtn}>
              <Icon name="chevron-left" style={iqopsStyles.arrowIcon} />
            </TouchableOpacity>
          ) : null}
          <FlatList
            data={pagesArray}
            contentContainerStyle={iqopsStyles.pagesRow}
            renderItem={({ item, index }) => (
              <TouchableOpacity
                key={`indxNum_${index}`}
                onPress={() => onPressHandler(item)}
                style={[
                  iqopsStyles.pageBtn,
                  item === currentPage && iqopsStyles.pageBtnActive,
                ]}
              >
                <Text
                  style={[
                    iqopsStyles.pageText,
                    item === currentPage && iqopsStyles.pageTextActive,
                  ]}
                >
                  {item}
                </Text>
              </TouchableOpacity>
            )}
            keyExtractor={(_, index) => index.toString()}
            horizontal={true}
            showsHorizontalScrollIndicator={false}
          />
          {currentPage != nPages ? (
            <TouchableOpacity onPress={() => onPressHandler(currentPage + 1)} style={iqopsStyles.arrowBtn}>
              <Icon name="chevron-right" style={iqopsStyles.arrowIcon} />
            </TouchableOpacity>
          ) : null}
        </View>
        <Text style={iqopsStyles.totalText}>
          {totalLabel || `Total Records : ${tasksCount || 0}`}
        </Text>
      </View>
    );
  }

  return <View style={{ flex: 1, flexDirection: 'row', backgroundColor: colors.primary, padding: 10, alignContent: 'center', alignItems: 'center', justifyContent: 'center' }}>
    {currentPage != 1 &&
      <TouchableOpacity onPress={() => onPressHandler(currentPage - 1)} >
        <MaterialCommunityIcons name="menu-left-outline" style={{ color: '#fff', fontSize: 38 }} />
      </TouchableOpacity>}
    <div
      ref={listRef}
      className="scrollable-list"
      onMouseDown={startDragging}
      onMouseMove={onDrag}
      onMouseUp={stopDragging}
      onMouseLeave={stopDragging}
    >
      {pagesArray?.map((i) => {
        return(
        <TouchableOpacity key={`indxNum_${i}`} onPress={() => onPressHandler(i)}>
          <Text style={{
            color: '#fff',
            fontSize: 18,
            marginHorizontal: 5,
            fontWeight: i === currentPage ? 'bold' : 'normal'
          }}>
            {i}
          </Text>
        </TouchableOpacity>
        )
      })}
    </div>
    {currentPage != nPages &&
      <TouchableOpacity onPress={() => onPressHandler(currentPage + 1)} >
        <MaterialCommunityIcons name="menu-right-outline" style={{ color: '#fff', fontSize: 38 }} />
      </TouchableOpacity>}
  </View>
};

const iqopsStyles = StyleSheet.create({
  wrap: {
    alignItems: "center",
    paddingVertical: 16,
    paddingHorizontal: 12,
    backgroundColor: "#FFFFFF",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  pagesRow: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 4,
  },
  pageBtn: {
    minWidth: 28,
    height: 28,
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 3,
    paddingHorizontal: 6,
  },
  pageBtnActive: {
    backgroundColor: "#D7EBFA",
  },
  pageText: {
    color: colors.primary,
    fontSize: 15,
    fontWeight: "500",
  },
  pageTextActive: {
    fontWeight: "700",
    color: colors.primary,
  },
  arrowBtn: {
    paddingHorizontal: 2,
  },
  arrowIcon: {
    color: colors.primary,
    fontSize: 28,
  },
  totalText: {
    marginTop: 10,
    fontSize: 13,
    color: "#8A94A6",
    textAlign: "center",
  },
});
